import { AppData } from '../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { UserAccountRequest } from '../models/login/useraccountrequest';
import { Router } from '@angular/router';
import { OTPToActivateAccount } from '../models/login/otptoactivateaccount';
import { ApiResponseModel } from '../models/api_response_model';
import { ForgotPasswordRequest } from '../models/login/forgotpassword.model';
import { ResendOTPRequest, ConfirmOTPRequest } from '../models/comm/resendotprequest.model';
import { ChangePasswordRequest } from '../models/login/changepassword.model';


@Injectable()
export class UserActivationService {
  // get
  //save
  //x for indicate operation



  constructor(private http: HttpClient, private injector: Injector, private router: Router) {
   
    
  }
  SaveUserAccountRequest(AddUserAccountRequest: UserAccountRequest) {
   
   
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}UserActivation/SaveUserAccountRequest`, (AddUserAccountRequest),
      {

      }

    ).pipe(catchError(this.handleError));
  }
  xConfirmOTPWithActivateAccount(xOTPToActivateAccount: OTPToActivateAccount) {
    
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}UserActivation/xConfirmOTPToActivation`, (xOTPToActivateAccount),
      {

      }

    ).pipe(catchError(this.handleError));
  }
  xReSendOTPToActivateAccount(xOTPToActivateAccount: OTPToActivateAccount) {

    return this.http.post<number>(`${AppData.GlobalApiUrl}UserActivation/xReSendOTPToActivateAccount`, (xOTPToActivateAccount),
      {

      }

    ).pipe(catchError(this.handleError));
  }
  xForgetPassword(xForgotPasswordRequest: ForgotPasswordRequest) {

    return this.http.post<number>(`${AppData.GlobalApiUrl}UserActivation/xForgetPassword`, (xForgotPasswordRequest),
      {

      }

    ).pipe(catchError(this.handleError));
  }
  xReSendOTPToActorOTPRequest(xResendOTPRequest: ResendOTPRequest) {

    return this.http.post<number>(`${AppData.GlobalApiUrl}UserActivation/xReSendOTPToActorOTPRequest`, (xResendOTPRequest),
      {

      }

    ).pipe(catchError(this.handleError));
  }

  xConfirmOTPToActorOTPRequest(xConfirmOTPRequest: ConfirmOTPRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}UserActivation/xConfirmOTPToActorOTPRequest`, (xConfirmOTPRequest),
      {

      }

    ).pipe(catchError(this.handleError));
  }




  xChangePassword(xChangePasswordRequest: ChangePasswordRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Login/xChangePassword`, (xChangePasswordRequest),
      {

      }

    ).pipe(catchError(this.handleError));
  }



  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    // // return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
